import classNames from 'classnames';
import React, {useState} from 'react';

import {addGenericErrorToast, LoadingSpinner} from '@albert-io/atomic';
import ClassroomInvitation from './ClassroomInvitation';
import getClassroomInvitationsQuery from './queries/getClassroomInvitationsQuery';
import useOnResourceStale from '../hooks/useOnResourceStale';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

interface Props extends PropsWithClassNameOptional {
  isWelcomePage: boolean;
}

export default function ClassroomInvitations({className, isWelcomePage}: Props) {
  const invitations = useStudentDashboard((state) => state.invitations);
  const isReloadingStudent = useStudentDashboard((state) => state.isReloadingStudent);
  const setInvitations = useStudentDashboard((state) => state.setInvitations);
  const studentEmail = useStudentDashboard((state) => state.student?.getEmail() ?? '');

  const [classroomInvitationsLastFetchedAt, setClassroomInvitationsLastFetchedAt] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useOnResourceStale(classroomInvitationsLastFetchedAt, () => {
    const query = getClassroomInvitationsQuery(studentEmail);

    setIsLoading(true);
    query.invalidateInterest();
    setClassroomInvitationsLastFetchedAt(Date.now());

    query
      .getResourcePromise()
      .then((fetchedInvitations) => {
        setInvitations(fetchedInvitations);
      })
      .catch((error) => {
        console.error(error);
        addGenericErrorToast();
      })
      .finally(() => {
        setIsLoading(false);
      });
  });

  if (!isLoading && invitations.size === 0) {
    return null;
  }

  return isReloadingStudent || isLoading ? (
    <LoadingSpinner bottomMarginLevel={0} size={2} />
  ) : (
    <ul className={classNames(className, 'flex list-none flex-col gap-x1 p-x0')}>
      {invitations.map((invitation) => (
        <ClassroomInvitation
          invitation={invitation}
          isWelcomePage={isWelcomePage}
          key={invitation.getId()}
        />
      ))}
    </ul>
  );
}
